import type {AppThunk} from '../../../../actions/types'
import {getSingleAgentArg} from '../../../../rest/agents'
import {getTabsArg} from '../../../../rest/tabs'
import {loadEndpoint} from '../../../../routes/loadEndpoint'
import type {LoadedEndpoints} from '../../../../routes/loadEndpoint'
import {getSingleAgent} from '../../../../selectors'
import {restApi} from '../../../../services/rest'
import type {AgentId} from '../../../../types'
import {OverviewAgentTabNamesEnum} from '../../../../types'
import {getTabParamsKey} from '../../../../utils/tabs'

import {agentPageOptions} from './AgentPage.rest'
import {preloadAgentSummary} from './AgentSummary/AgentSummary.preload'

export const preloadAgentPage =
  (agentId: AgentId, tab: string | null | undefined): AppThunk<LoadedEndpoints> =>
  (dispatch, getState) => {
    const loadedAgent = dispatch(
      loadEndpoint(
        restApi.endpoints.getAgentNormalized,
        getSingleAgentArg(agentId, agentPageOptions),
      ),
    )
    const preloadedEndpoints: LoadedEndpoints = [
      loadedAgent,
      dispatch(
        loadEndpoint(restApi.endpoints.getTabs, getTabsArg(getTabParamsKey({agentId}), false)),
      ),
      dispatch(loadEndpoint(restApi.endpoints.getPoolPermissions, undefined)),
    ]

    const isSummaryTab = tab == null || tab === OverviewAgentTabNamesEnum.SUMMARY
    if (isSummaryTab) {
      loadedAgent.result.then(() => {
        const buildId = getSingleAgent(getState(), agentId)?.build
        dispatch(preloadAgentSummary(buildId))
      })
    }

    return preloadedEndpoints
  }
